// extracted by mini-css-extract-plugin
export default {"heading":"OwnerTermsPage_heading__gAKVm","content":"OwnerTermsPage_content__7aKxJ"};